import React, {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/actions/index";
import "./indeterminateCheckbox.css";
import styled from "styled-components";
import { useTable, useRowSelect, useSortBy, useFilters } from "react-table";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import urlLinks from "../../UrlLinks";
import Axios from "axios";
import styles from "./index.module.scss";
import BulkUpdateModal from "../../Utils/dialogs/BulkUpdateModal";
import OnboardingModal from "../../Utils/dialogs/OnboardingModal";
import Pagination from "../../Utils/Pagination";
import * as moment from "moment";
import NoRecord from "./Assets/noRecord.svg";
import ScaleLoader from "react-spinners/ScaleLoader";
import { AuthContext } from "../../services/AuthProvider";
import UrlLinks from "../../UrlLinks";
import JobFilter from "../../Utils/FilterComponents/JobFilter";
import SearchBar from "../../Utils/functions/LeadSearchBar";
import CustomStatusDropdown from "./Functions/CustomStatusDropdown";
import ExportButton from "../../Utils/functions/ExportButton";
import ActionsDropdown from "../../Utils/functions/ActionsDropdown";
import AssignToRecruiter from "./components/AssignToRecruiter";
import FilterDrawer from "./components/FilterDrawer";
import filterIcon from "../ProjectConfig/filterIcon.svg";
import filterIconMarked from "../ProjectConfig/filterIconMarked.svg";
import RemarkOkayGo from "./components/RemarkOkayGo";
import HistoryModal from "../../Utils/dialogs/HistoryModal";
import DownloadDocuments from "./components/DownloadDoc";
import RemoveExtraSpaces from "../../Utils/functions/RemoveExtraSpaces";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Checkbox, Drawer, Tabs, Tab } from "@material-ui/core";
import { urlToPromise } from "../../Utils/CommonFunctions";
import { AppData } from "../../context/context";
import { applicationDbColumns } from "../../Utils/ColumnTemplate";
import { trackEvent, FE_EVENTS } from '../../Utils/analytics';

const Styles = styled.div`
  padding: 1rem;
  .tableContainer {
    overflow-x: scroll;
    border: 1px solid #cfcfcf;
    border-radius: 5px;
    max-height: 74vh;
  }
  .tableContainer::-webkit-scrollbar {
    width: 0.75em;
  }

  .tableContainer::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  .tableContainer::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
  table {
    border-spacing: 0;
    width: max-content;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      :last-child {
        border-left: 0;
      }
      background-color: #1c4980 !important;
      color: #ffffff;
    }
    th,
    td {
      padding: 20px 15px;
    }

    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #cfcfcf;
      border-right: 1px solid #cfcfcf;
      background-color: white;
      nth-last-child(2) {
        border-right: 0;
      }
      :last-child {
        border-right: 0;
      }

      input {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        border: 0;
      }
    }
  }

  .pagination {
    padding: 0.5rem;
  }
`;

const useStyles = makeStyles((theme) => ({
  tabs: {
    "& .MuiTab-root": {
      minWidth: "auto",
      margin: "0 10px",
      textTransform: "capitalize",
      fontSize: "16px",
      fontWeight: "600",
      "&:first-child": {
        margin: "0",
      },
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: "#1C4980",
    },
    "& .MuiTab-textColorPrimary.Mui-disabled": {
      color: "#CECECE",
    },
  },
  remarkButton: {
    textTransform: "capitalize !important",
    width: "129px !important",
    display: "flex !important",
    justifyContent: "space-between !important",
    fontWeight: "400 !important",
  },
}));

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <React.Fragment>
      <Checkbox ref={resolvedRef} {...rest} />
    </React.Fragment>
  );
});

const ExternalWorker = (props) => {
  /** accessing states from redux store **/

  const { users, applicationDb } = useSelector((state) => state);
  const {
    loader,
    currentPage,
    perPage,
    totalRows,
    totalPages,
    isFilter,
    selectedAssignIds,
    selectedUserIds,
    openFilterDrawer,
    allRecord,
  } = users;
  const {
    curLeadId,
    tabValue,
    multiplePreferredPincodes,
    multiplePreferredLanguages,
    multipleAssets,
  } = applicationDb;

  /** useDispatch is used to update states to redux store **/

  const dispatch = useDispatch();
  const {
    setLoader,
    setModalLoader,
    setCurrentPage,
    setPerPage,
    setTotalRows,
    setTotalPages,
    setIsFilter,
    setSelectedAssignIds,
    setSelectedUserIds,
    setOpenFilterDrawer,
    setCurLeadId,
    setTabValue,
    setAllRecord,
  } = bindActionCreators(actionCreators, dispatch);

  /** other states **/

  const classes = useStyles();
  const { showToast } = useContext(AuthContext);
  const { userAction } = useContext(AppData);
  const cancelTokens = useRef({
    mainListingData: null,
    applicationStatus: null,
    userNotification: null,
  });
  const cancelTokenSource = Axios.CancelToken.source();
  const [isDataVisible, setIsDataVisible] = useState(true);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [actions, setActions] = useState(-1);
  const [allRecordLoading, setAllRecordLoading] = useState(false);
  const [searchByAuto, setSearchByAuto] = useState("");
  const [searchKeyByAuto, setSearchKeyByAuto] = useState("");
  const [searchBy, setSearchBy] = useState("");
  const [filterUrl, setFilterUrl] = useState("");
  const [docListLoader, setDocListLoader] = useState(null);
  const [downloadDocError, setDownloadDocError] = useState(null);
  const [leadCityId, setLeadCityId] = useState([]);
  const [leadSourceId, setLeadSourceId] = useState([]);
  const [preferredPincodes, setPreferredPincodes] = useState([]);
  const [preferredLanguages, setPreferredLanguages] = useState([]);
  const [assets, setAssets] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [searchActions, setSearchActions] = useState("Search by");
  const [searchList, setSearchList] = useState([]);
  const [subStatusList, setSubStatusList] = useState([]);
  const [searchError, setSearchError] = useState(false);
  const [toggleStatusUpdated, setToggleStatusUpdated] = useState(false);
  const [recruiterList, setRecruiterList] = useState([]);
  const [opsList, setOpsList] = useState([]);
  const [jobFilterOption, setJobFilterOption] = useState("active");
  const [jobList, setJobList] = useState([]);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [openAssignRecruiterModal, setOpenAssignRecruiterModal] =
    useState(false);
  const [openAssignOpsModal, setOpenAssignOpsModal] = useState(false);
  const [openBulkUpdateModal, setOpenBulkUpdateModal] = useState(false);
  const [openUploadLeadModal, setOpenUploadLeadModal] = useState(false);
  const [remarkChanged, setRemarkChanged] = useState("");
  const [openRemarkModal, setOpenRemarkModal] = useState(false);
  const [remarkRecord, setRemarkRecord] = useState([]);
  const [openApplicationHistoryModal, setOpenApplicationHistoryModal] =
    useState(false);
  const [openWorkerHistoryModal, setOpenWorkerHistoryModal] = useState(false);
  const [openMpaModal, setOpenMpaModal] = useState(false);
  const [historyColumns, setHistoryColumns] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    id: "active",
    name: "Select Job",
  });
  const [selectedSubStatus, setSelectedSubStatus] = useState(null);
  const [filters, setFilters] = useState({
    appliedBetween: [null, null],
    assets: "",
    gender: "",
    jobId: "",
    leadCity: "",
    leadSource: "",
    mpaName: "",
    preferredLanguages: "",
    preferredPincodes: "",
    qualifications: "",
    searchBy: "",
    searchKey: "",
    status: "",
    statusUpdatedBetween: [null, null],
    recruiterAssignedBetween: [null, null],
    recruiterId: "",
    tabs: {
      FreshLeads: true,
      Applied: false,
      Training: false,
      Work: false,
      Rejected: false,
    },
  });

  const assignedProjects =
    JSON.parse(localStorage.getItem("projectList")) || [];
  const assignedProjectIds = assignedProjects?.map((proj) => {
    return proj.id;
  });

  const searchBarList = ["Lead ID", "Aadhar No", "Pincode", "Phone No"];
  const jobFilterOptionList = [
    {
      id: "active",
      name: "Active",
    },
    {
      id: "inactive",
      name: "In-Active",
    },
  ];

  const applicationStatusList = {
    1: "Applied",
    2: "Not eligible",
    3: "Backed out",
    4: "DNA 1",
    14: "DNA 2",
    15: "DNA 3",
    5: "Interview Pending",
    6: "Interview Done",
    7: "Training done",
    8: "Training pending",
    9: "Ready to work",
    10: "Started working",
    11: "No task available",
    20: "Document pending",
    21: "Document done",
    18: "Follow up 1",
    19: "Follow up 2",
    16: "Not sure",
    12: "Rejected (system)",
    13: "Not Eligible (system)",
    23: "Waitlist",
  };

  const tabsData = [
    { label: "Fresh Leads", value: "FreshLeads" },
    { label: "Applied", value: "Applied" },
    { label: "Training", value: "Training" },
    { label: "Working Status", value: "Work" },
    { label: "Rejected", value: "Rejected" },
  ];

  const actionList = [
    !filters.tabs.FreshLeads
      ? {
          value: "assignOps",
          label: "Assign to Ops",
        }
      : {},
    {
      value: "assignRecruiter",
      label: "Assign to Recruiter",
    },
    {
      value: "tagMpa",
      label: "Tag MPA",
    },
    {
      value: "uploadData",
      label: "Upload Data",
    },
  ];

  const uploadDataList = [
    !filters.tabs.FreshLeads && !filters.tabs.Rejected
      ? {
          value: "bulkUpdate",
          label: "Bulk update",
        }
      : {},
    {
      value: "uploadLeads",
      label: "Upload leads",
    },
  ];

  const updateMyData = () => {
    getExternalWorkerList(perPage, currentPage);
  };

  const resetFiltersWithoutSearch = () => {
    setIsFilter(false);
    const filterList = {
      appliedBetween: [null, null],
      assets: "",
      gender: "",
      jobId: filters.jobId,
      leadCity: "",
      leadSource: "",
      mpaName: "",
      preferredLanguages: "",
      preferredPincodes: "",
      qualifications: "",
      searchBy: filters.searchBy,
      searchKey: filters.searchKey,
      status: filters.status,
      statusUpdatedBetween: [null, null],
      recruiterAssignedBetween: [null, null],
      recruiterId: "",
      tabs: {
        FreshLeads: filters.tabs.FreshLeads,
        Applied: filters.tabs.Applied,
        Training: filters.tabs.Training,
        Work: filters.tabs.Work,
        Rejected: filters.tabs.Rejected,
      },
    };

    let customUrl = "";
    if (filters["tabs"]) {
      for (const tab in filters.tabs) {
        if (!filters.tabs.FreshLeads && filters.tabs[tab]) {
          customUrl = `${customUrl}&applicationStatus=${tab}`;
          break;
        }
      }
    }
    if (!filters.tabs.FreshLeads && filters.jobId) {
      customUrl = customUrl + "&jobId=" + filters.jobId;
    }
    if (
      (filters["status"] && filters["status"] !== 17) ||
      filters["status"] === 0
    ) {
      customUrl = customUrl + "&subStatus=" + filters.status;
    }
    if (openFilterDrawer) {
      if (filters.searchKey !== "" && filters.searchBy) {
        customUrl =
          customUrl +
          "&searchField=" +
          filters.searchKey +
          "&searchValue=" +
          filters.searchBy;
      }
    } else {
      if (filters.searchKey && filters.searchBy) {
        customUrl = customUrl + "&searchBy=" + filters.searchBy;
      }
    }

    setFilterUrl(customUrl);
    setFilters(filterList);
    setLeadCityId([]);
    setLeadSourceId([]);
    setPreferredPincodes([]);
    setPreferredLanguages([]);
    setAssets([]);
    setCurLeadId([], [], [], [], []);
    setCurrentPage(1);
    return filterList;
  };

  const createDocumentZip = (documents, okaygoId, name) => {
    var zip = new JSZip();
    var fileUrl = "";
    var profilePhotoURL = "";
    var photoName = "";

    documents?.forEach(function (doc, index) {
      var filename = doc?.file_name;
      filename = filename.substring(0, filename.indexOf("?"));
      if (doc?.file_path.substring(0, 5) === "http:") {
        // in case if it comes https, link wont become httpss
        fileUrl = "https" + doc.file_path.substring(4, doc.file_path.length);
      } else {
        fileUrl = doc?.file_path;
      }
      zip.file(filename, urlToPromise(fileUrl), { binary: true });
      if (
        doc.profilePhoto !== null &&
        doc.profilePhoto !== "" &&
        !profilePhotoURL
      ) {
        if (doc.profilePhoto.substring(0, 5) === "http:") {
          profilePhotoURL =
            "https" + doc.profilePhoto.substring(4, doc.profilePhoto.length);
        } else {
          profilePhotoURL = doc.profilePhoto;
        }
        if (profilePhotoURL.includes(".jpg?")) {
          photoName = `${name.replaceAll(" ", "")}_Profile_Photo.jpg`;
        } else if (profilePhotoURL.includes(".png?")) {
          photoName = `${name.replaceAll(" ", "")}_Profile_Photo.png`;
        }
        zip.file(photoName, urlToPromise(profilePhotoURL), { binary: true });
      }
    });

    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, `${okaygoId}_${name}_Documents`);
      setDocListLoader(null);
    });
  };

  const getDocumentList = (userId, name) => {
    setDocListLoader(userId);
    Axios.get(
      `${urlLinks.baseUrl}${urlLinks.workerUrls.docList}${parseInt(userId)}`,
      {
        headers: {
          Authorization: "1",
        },
      }
    )
      .then((response) => {
        if (response?.data?.response?.content?.length > 0) {
          createDocumentZip(response.data.response.content, userId, name);
        } else {
          setDocListLoader(null);
          setDownloadDocError({
            err: <span>No Document Available</span>,
            userId: userId,
          });
        }
      })
      .catch((error) => {
        setDocListLoader(null);
        setDownloadDocError({
          err: <span style={{ color: "red" }}>Error while downloading</span>,
          userId: userId,
        });
      });
  };

  const handleSearch = () => {
    setFilters({ ...filters, searchBy: searchBy, searchKey: searchKey });
    setSearchByAuto(searchBy);
    setSearchKeyByAuto(searchKey);
  };

  const handleSearchClose = () => {
    setFilters({ ...filters, searchBy: "" });
    setSearchBy("");
    setFilterUrl("");
    setSearchByAuto("");
  };

  const updateFilterUrl = () => {
    let url = "";

    // Tab Change
    if (filters["tabs"]) {
      // Find the tab with a value of true
      for (const tab in filters.tabs) {
        if (!filters.tabs.FreshLeads && filters.tabs[tab]) {
          url = `${url}&applicationStatus=${tab}`;
          break;
        }
      }
    }

    // Job Filters
    if (filters["jobId"]) {
      url = `${url}&jobId=${filters["jobId"]}`;
    }

    // Search By
    if (filters["searchBy"] !== "" && filters["searchKey"] !== "") {
      url = `${url}&searchField=${filters["searchKey"]}&searchValue=${filters["searchBy"]}`;
    }

    // Applied on url
    if (filters["appliedBetween"][0] && !filters["appliedBetween"][1])
      url = `${url}&appliedOnFrom=${moment(filters["appliedBetween"][0]).format(
        "YYYY-MM-DD"
      )}&appliedOnTo=${moment(new Date()).format("YYYY-MM-DD")} 23:59:59`;
    if (!filters["appliedBetween"][0] && filters["appliedBetween"][1])
      url = `${url}&appliedOnFrom=2019-01-01&appliedOnTo=${moment(
        filters["appliedBetween"][1]
      ).format("YYYY-MM-DD")} 23:59:59`;
    if (filters["appliedBetween"][0] && filters["appliedBetween"][1])
      url = `${url}&appliedOnFrom=${moment(filters["appliedBetween"][0]).format(
        "YYYY-MM-DD"
      )}&appliedOnTo=${moment(filters["appliedBetween"][1]).format(
        "YYYY-MM-DD"
      )} 23:59:59`;

    // Lead City
    if (filters["leadCity"]) {
      url = `${url}&city=${filters["leadCity"]}`;
    }

    // Lead Source
    if (filters["leadSource"]) {
      url = `${url}&source=${filters["leadSource"]}`;
    }

    // Gender url
    if (filters["gender"]) {
      url = `${url}&gender=${filters["gender"].id}`;
    }

    // MPA Name
    if (filters["mpaName"]) {
      url = `${url}&mpaId=${filters["mpaName"].id}`;
    }

    // Preferred Pincodes url
    if (filters["preferredPincodes"]) {
      url = `${url}&preferredPincodes=${filters["preferredPincodes"]}`;
    }

    // Preferred Languages url
    if (filters["preferredLanguages"]) {
      url = `${url}&languages=${filters["preferredLanguages"]}`;
    }

    // Assets url
    if (filters["assets"]) {
      url = `${url}&assests=${filters["assets"]}`;
    }

    // Qualifications url
    if (filters["qualifications"]) {
      url = `${url}&qualification=${filters["qualifications"].id}`;
    }

    // Recruiter ID
    if (
      filters.tabs.FreshLeads &&
      filters["recruiterId"] &&
      filters["recruiterId"].id == "-1"
    ) {
      url = `${url}&recruiterAssigned=${filters["recruiterId"].id}`;
    } else if (
      filters.tabs.FreshLeads &&
      filters["recruiterId"] &&
      filters["recruiterId"].id !== "-1"
    ) {
      url = `${url}&recruiterAssigned=${filters["recruiterId"].id}`;
    } else if (!filters.tabs.FreshLeads && filters["recruiterId"]) {
      url = `${url}&recruiterAssigned=${filters["recruiterId"].id}`;
    }

    // Recruiter assigned on url
    if (
      filters["recruiterAssignedBetween"][0] &&
      !filters["recruiterAssignedBetween"][1]
    )
      url = `${url}&recruiterAssignedOnFrom=${moment(
        filters["recruiterAssignedBetween"][0]
      ).format("YYYY-MM-DD")}&recruiterAssignedOnTo=${moment(new Date()).format(
        "YYYY-MM-DD"
      )} 23:59:59`;
    if (
      !filters["recruiterAssignedBetween"][0] &&
      filters["recruiterAssignedBetween"][1]
    )
      url = `${url}&recruiterAssignedOnFrom=2019-01-01&recruiterAssignedOnTo=${moment(
        filters["recruiterAssignedBetween"][1]
      ).format("YYYY-MM-DD")} 23:59:59`;
    if (
      filters["recruiterAssignedBetween"][0] &&
      filters["recruiterAssignedBetween"][1]
    )
      url = `${url}&recruiterAssignedOnFrom=${moment(
        filters["recruiterAssignedBetween"][0]
      ).format("YYYY-MM-DD")}&recruiterAssignedOnTo=${moment(
        filters["recruiterAssignedBetween"][1]
      ).format("YYYY-MM-DD")} 23:59:59`;

    // Status Updated on url
    if (
      filters["statusUpdatedBetween"][0] &&
      !filters["statusUpdatedBetween"][1]
    )
      url = `${url}&updatedOnFrom=${moment(
        filters["statusUpdatedBetween"][0]
      ).format("YYYY-MM-DD")}&updatedOnTo=${moment(new Date()).format(
        "YYYY-MM-DD"
      )} 23:59:59`;
    if (
      !filters["statusUpdatedBetween"][0] &&
      filters["statusUpdatedBetween"][1]
    )
      url = `${url}&updatedOnFrom=2019-01-01&updatedOnTo=${moment(
        filters["statusUpdatedBetween"][1]
      ).format("YYYY-MM-DD")} 23:59:59`;
    if (
      filters["statusUpdatedBetween"][0] &&
      filters["statusUpdatedBetween"][1]
    )
      url = `${url}&updatedOnFrom=${moment(
        filters["statusUpdatedBetween"][0]
      ).format("YYYY-MM-DD")}&updatedOnTo=${moment(
        filters["statusUpdatedBetween"][1]
      ).format("YYYY-MM-DD")} 23:59:59`;

    // Sub Status url
    if (
      (filters["status"] && filters["status"] !== 17) ||
      filters["status"] === 0
    ) {
      url = `${url}&subStatus=${filters["status"]}`;
    }

    return url;
  };

  const ApplyFilters = () => {
    let url = updateFilterUrl();
    setFilterUrl(url);
    setFilters(filters);
    setCurrentPage(1);
  };

  // Function to open a specific user data
  const handleUserModal = async (event, row, type) => {
    switch (type) {
      case "remark": {
        setRemarkRecord(row);
        setOpenRemarkModal(true);
        return;
      }
      case "applicationHistory": {
        setModalLoader(true);
        setOpenApplicationHistoryModal(true);
        setHistoryColumns([
          {
            key: "jobName",
            label: "Job Name",
          },
          {
            key: "appliedOn",
            label: "Applied on",
          },
          {
            key: "jobStatus",
            label: "Job Status",
          },
          {
            key: "statusUpdateOn",
            label: "Status update on",
          },
          {
            key: "statusUpdateBy",
            label: "Status update by",
          },
        ]);
        await Axios.get(
          `${urlLinks.baseUrl}${urlLinks.leadData.applicationHistory}?assignId=${row.assignId}`
        )
          .then((res) => {
            setHistoryList(res.data.response);
            setModalLoader(false);
          })
          .catch((err) => {
            console.log("err", err);
            showToast(
              "error",
              "Error",
              "Something went wrong, please try after sometime."
            );
          });
        return;
      }
      case "workerHistory": {
        setModalLoader(true);
        setOpenWorkerHistoryModal(true);
        setHistoryColumns([
          {
            key: "clientName",
            label: "Client Name",
          },
          {
            key: "vertical",
            label: "Vertical",
          },
          {
            key: "startDate",
            label: "Start Date",
          },
          {
            key: "status",
            label: "Status",
          },
        ]);
        await Axios.get(
          `${urlLinks.baseUrl}${urlLinks.leadData.getWorkerHistory}?lead_id=${row.leadId}`
        )
          .then((res) => {
            setHistoryList(res.data.response);
            setModalLoader(false);
          })
          .catch((err) => {
            console.log("err", err);
            showToast(
              "error",
              "Error",
              "Something went wrong, please try after sometime."
            );
          });
        return;
      }
      default:
        return;
    }
  };

  // Function to get communication type and message
  const getNotification = async (data) => {
    let userIds = [];
    if (cancelTokens.current.userNotification) {
      cancelTokens.current.userNotification.cancel(
        "Operation canceled due to new request."
      );
    }
    cancelTokens.current.userNotification = cancelTokenSource;

    try {
      data.map((el) => {
        userIds.push(el.userId);
      });
      userIds = userIds.join(",");

      const response = await Axios.get(
        `${UrlLinks.baseUrl}${UrlLinks.leadData.getUserNotification}?userIds=${userIds}`,
        {
          cancelToken: cancelTokenSource.token,
        }
      );
      if (response) {
        return response.data.response;
      }
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        console.error("Error:", error);
      }
    }

    return null;
  };

  //Function to create export data as per the main listing order
  const makeLeadExportData = (response) => {
    let extractedData = [];
    response?.map((el) => {
      const assignedTo = el.recruiterAssigned
        ? "rec"
        : el.opsAssignedName
        ? "ops"
        : "";
      const assignedName =
        assignedTo === "rec"
          ? el.recruiterAssigned
          : assignedTo === "ops"
          ? el.opsAssignedName
          : "";
      const assignedNumber =
        assignedTo === "rec" ? el.recruiterAssignedNumber || "" : "";
      const assignedOn =
        assignedTo === "rec"
          ? el.recruiterAssignedOn
          : assignedTo === "ops"
          ? el.opsAssignedOn
          : "";

      extractedData.push({
        "Lead ID": el.leadId || "",
        Name: el.name || "",
        "Phone Number": el.phoneNumber || "",
        Email: el.phoneNumber || "",
        "Perm. Address": el.address || "",
        City: el.city || "",
        Gender: el.gender ? el.gender : "",
        DOB: el.dateOfBirth ? moment(el.dateOfBirth).format("DD/MM/YYYY") : "",
        "Preferred Pincodes": el.preferredPincodes ? el.preferredPincodes : "",
        Languages: el.languages ? el.languages : "",
        Assets: el.assests ? el.assests : "",
        Qualifications: el.qualification ? el.qualification : "",
        Source: el.source || "",
        "MPA Name": el.mpaName || "",
        Status: el.applicationStatus
          ? applicationStatusList[
              Object.keys(applicationStatusList).find(
                (status) => status == el.applicationStatus
              )
            ]
          : "",
        "Applied On": el.appliedOn
          ? moment(el.appliedOn).format("DD/MM/YYYY hh:mm a")
          : "-",
        "Status Updated On": el.updatedOn
          ? moment(el.updatedOn).format("DD/MM/YYYY hh:mm a")
          : "-",
        "Assigned To":
          `${assignedTo ? `${assignedName} ${assignedNumber}` : ""}` || "",
        "Assigned On": assignedOn
          ? moment(assignedOn).format("DD/MM/YYYY hh:mm a")
          : "-",
        docAvailable: el.docAvailable ? "Yes" : "No",
        remarks: el.remarks || "",
        "% Profile Complete": el.profilePercentage
          ? el.profilePercentage + "%"
          : "",
      });
      return true;
    });
    return extractedData;
  };

  //Function to call export data
  const createAllRecordExcel = async () => {
    trackEvent(FE_EVENTS.APPLICATION_EXPORT);
    if (!openBulkUpdateModal) {
      setAllRecordLoading(true);
    }

    let excelExportedBy = `excelExportedBy=${localStorage.getItem(
      "userID"
    )}&exportExcel=1`;

    let excelData = await Axios.get(
      `${urlLinks.baseUrl}${
        urlLinks.leadData.mainListing
      }?${excelExportedBy}&applied=${
        filters.tabs.FreshLeads ? 0 : 1
      }${filterUrl}`,
      {
        headers: {
          Authorization: "1",
        },
      }
    )
      .then((response) => {
        if (response) {
          if (openBulkUpdateModal) {
            let asignIdResponse = response.data.response;
            return asignIdResponse;
          } else {
            setAllRecord(makeLeadExportData(response.data.response));
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    return openBulkUpdateModal ? excelData : "";
  };

  //Function to add communication type and message in the table.
  const statusUpdatedColumn = async (data) => {
    let newData = [];
    let allCommData = await getNotification(data);

    if (allCommData) {
      data?.forEach((res, i) => {
        let comm = allCommData.filter(
          (commData) => commData.userId === res.userId
        );
        newData.push({
          ...res,
          commType: comm[0].message ? "Push notification" : "-",
          lastCommSent: comm[0].message || "-",
        });
      });
      setData(newData);
    }
  };

  const checkDataVisible = (tabValue, selectedOption) => {
    if (tabValue === "FreshLeads") {
      setIsDataVisible(true);
      return true;
    } else {
      if (selectedOption.id === "active" || selectedOption.id === "inactive") {
        setIsDataVisible(false);
        return false;
      } else {
        setIsDataVisible(true);
        return true;
      }
    }
  };

  //Function to call main listing.
  const getExternalWorkerList = async (rows, pageNo) => {
    const flag = checkDataVisible(tabValue, selectedOption);

    if (flag) {
      // Cancel the previous request if it exists
      if (cancelTokens.current.mainListingData) {
        cancelTokens.current.mainListingData.cancel(
          "Operation canceled due to new request."
        );
      }
      cancelTokens.current.mainListingData = cancelTokenSource;
      setAllRecord([]);
      if (localStorage.getItem("roleType")) {
        setLoader(true);

        let recruiterUrl = "";
        if (filters.tabs.FreshLeads) {
          if (filters["recruiterId"] && filters["recruiterId"].id == "-1") {
            recruiterUrl = `&assigned=0`;
          } else if (
            filters["recruiterId"] &&
            filters["recruiterId"].id !== "-1"
          ) {
            recruiterUrl = `&assigned=1`;
          } else if (!filters["recruiterId"]) {
            recruiterUrl = `&assigned=1`;
          }
        }

        let mainUrl = `${urlLinks.baseUrl}${
          urlLinks.leadData.mainListing
        }?page_no=${pageNo - 1}&rows=${rows}&applied=${
          filters.tabs.FreshLeads ? 0 : 1
        }${
          !filters.tabs.FreshLeads &&
          localStorage.getItem("roleType") !== "6" &&
          localStorage.getItem("roleType") !== "31"
            ? `&projectIds=${assignedProjectIds}`
            : ""
        }${recruiterUrl}${filterUrl}`;

        let newUrl = "";
        newUrl = new URL(mainUrl);
        let params = new URLSearchParams(newUrl.search);
        if (filters.tabs.FreshLeads) {
          // List of parameters to delete
          let paramsToDelete = ["applicationStatus", "jobId"];
          paramsToDelete?.forEach((param) => {
            params.delete(param);
          });

          newUrl.search = params.toString();
          mainUrl = newUrl.toString();
        }

        try {
          const response = await Axios.get(mainUrl, {
            cancelToken: cancelTokenSource.token,
          });
          if (response) {
            setTotalRows(response.data.response?.totalElements);
            setTotalPages(response.data.response?.totalPages);
            if (currentPage > response.data.response?.totalPages) {
              setCurrentPage(1);
            }
            setData(
              response.data.response ? response.data.response.content : []
            );
            statusUpdatedColumn(response.data.response?.content);
          }
          setLoader(false);
        } catch (error) {
          if (Axios.isCancel(error)) {
            console.log("Request canceled:", error.message);
          } else {
            console.error("Error:", error);
            setLoader(false);
          }
        }
      }
    } else {
      setTotalRows(0);
      setTotalPages(1);
      setCurrentPage(1);
      setData([]);
    }
  };

  const handlePageChange = (page) => {
    getExternalWorkerList(perPage, page);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    getExternalWorkerList(newPerPage, 1);
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const handleActions = (event, type, val) => {
    // update status validations
    if (event.target.value === "assignRecruiter") {
      setOpenAssignRecruiterModal(true);
    } else if (event.target.value === "assignOps") {
      setOpenAssignOpsModal(true);
    } else if (event.target.value === "tagMpa") {
      setOpenMpaModal(true);
    }

    // search bar list validations
    else if (event.target.value === "Lead ID") {
      setSearchKey("leadId");
      setSearchActions("Lead ID");
    } else if (event.target.value === "Aadhar No") {
      setSearchKey("aadhar");
      setSearchActions("Aadhar No");
    } else if (event.target.value === "Pincode") {
      setSearchKey("pincode");
      setSearchActions("Pincode");
    } else if (event.target.value === "Phone No") {
      setSearchKey("phoneNumber");
      setSearchActions("Phone No");
    }

    // validations based on type
    if (type === "updateDataAppDb") {
      if (val.value === "uploadLeads") {
        setOpenUploadLeadModal(true);
      } else if (val.value === "bulkUpdate") {
        setOpenBulkUpdateModal(true);
      }
    }
  };

  // Function to handle tabs
  const handleTabChange = (event, newIndex) => {
    if (!filters.tabs[newIndex]) {
      setTabValue(newIndex);

      // Update filters.tabs based on the newIndex
      const updatedTabs = Object.fromEntries(
        Object.keys(filters.tabs).map((key) => [key, key === newIndex])
      );

      setFilters({
        ...filters,
        tabs: updatedTabs,
      });
    }
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const makeRecruiterData = (data) => {
    let list = [];
    data.map((el) => {
      if (el.isActive) {
        list.push({
          id: el.recruiterId,
          name: `${el.firstName} ${el.lastName ? el.lastName : ""}`,
          phoneNumber: el.phoneNumber,
        });
      }
      return true;
    });
    return list;
  };

  const makeOpsData = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.userId,
        name: `${el.name}`,
      });
      return true;
    });
    return list;
  };

  const makeSearchList = (data) => {
    let list = [];
    data.map((el) => {
      if (el.typeKey != 11 && el.typeKey != 17) {
        list.push({
          typeKey: el.typeKey,
          typeValue: el.typeValue,
        });
      }
      return true;
    });
    list.push({ typeKey: 11, typeValue: "No task available" });
    return list;
  };

  const makeSubStatusList = (data, tab) => {
    let list = [];
    const sortStatusOrderFreshLeads = [17, 18, 19, 4, 16];
    const sortStatusOrderApplied = [1, 13, 24, 12, 99, 21];
    const sortStatusOrderTraining = [8, 7];
    const sortStatusOrderWork = [9, 11, 10];
    const sortStatusOrderRejected = [3, 33];

    data.map((el) => {
      if (tab === "FreshLeads") {
        const isAvailable = sortStatusOrderFreshLeads.filter(
          (e) => e === el.typeKey
        );
        if (isAvailable.length > 0) {
          list.push({
            id: el.typeKey,
            name: el.typeKey === 4 ? "D.N.A" : el.typeValue,
          });
        }
      }
      if (tab === "Applied") {
        const isAvailable = sortStatusOrderApplied.filter(
          (e) => e === el.typeKey
        );
        if (isAvailable.length > 0) {
          list.push({
            id: el.typeKey,
            name:
              el.typeKey === 12
                ? "Screening Failed"
                : el.typeKey === 21
                ? "Doc Verified"
                : el.typeKey === 24
                ? "Profile Done"
                : el.typeValue,
          });
        }
      }
      if (tab === "Training") {
        const isAvailable = sortStatusOrderTraining.filter(
          (e) => e === el.typeKey
        );
        if (isAvailable.length > 0) {
          list.push({
            id: el.typeKey,
            name: el.typeKey === 7 ? "Training Passed" : el.typeValue,
          });
        }
      }
      if (tab === "Work") {
        const isAvailable = sortStatusOrderWork.filter((e) => e === el.typeKey);
        if (isAvailable.length > 0) {
          list.push({
            id: el.typeKey,
            name: el.typeValue,
          });
        }
      }
      if (tab === "Rejected") {
        const isAvailable = sortStatusOrderRejected.filter(
          (e) => e === el.typeKey
        );
        if (isAvailable.length > 0) {
          list.push({
            id: el.typeKey,
            name: el.typeValue,
          });
        }
      }
      return true;
    });

    if (tab === "FreshLeads") {
      list.push({
        id: 17,
        name: "All",
      });
      list.sort((a, b) => {
        return (
          sortStatusOrderFreshLeads.indexOf(a.id) -
          sortStatusOrderFreshLeads.indexOf(b.id)
        );
      });
    } else if (tab === "Applied") {
      list.push({
        id: 99,
        name: "Screening Passed",
      });
      list.sort(
        (a, b) =>
          sortStatusOrderApplied.indexOf(a.id) -
          sortStatusOrderApplied.indexOf(b.id)
      );
    } else if (tab === "Training") {
      list.sort(
        (a, b) =>
          sortStatusOrderTraining.indexOf(a.id) -
          sortStatusOrderTraining.indexOf(b.id)
      );
    } else if (tab === "Work") {
      list.sort(
        (a, b) =>
          sortStatusOrderWork.indexOf(a.id) - sortStatusOrderWork.indexOf(b.id)
      );
    } else if (tab === "Rejected") {
      list.sort(
        (a, b) =>
          sortStatusOrderRejected.indexOf(a.id) -
          sortStatusOrderRejected.indexOf(b.id)
      );
    }

    setFilters((prev) => ({
      ...prev,
      status: tab === "FreshLeads" ? "" : list[0].id,
    }));
    setSelectedSubStatus({ id: list[0].id, name: list[0].name });
    return list;
  };

  const makeJobData = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.jobId,
        name: `${el.jobId} - ${el.client} - ${el.jobTitle}`,
      });
      return true;
    });
    return list;
  };

  const fetchColumn = () => {
    const fetchedColumn = applicationDbColumns(
      data,
      DownloadDocuments,
      applicationStatusList,
      handleUserModal,
      classes,
      userAction,
      IndeterminateCheckbox
    );
    setColumns(fetchedColumn);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleAllRowsSelected,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      updateMyData,
      getDocumentList,
      docListLoader,
      downloadDocError,
      showToast,
      setLoader,
      filters,
      setFilters,
      manualSortBy: true,
    },
    useFilters,
    useSortBy,
    useRowSelect
  );

  const table = (
    <div className={`tableContainer ${styles.tableContainer}`}>
      <table {...getTableProps()}>
        <thead className="thead">
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  className={
                    column.render("Header") === "Name"
                      ? `${
                          !filters.tabs.FreshLeads
                            ? "stickWorkerName95"
                            : "stickWorkerNameV2"
                        } zIndex1080 header`
                      : column.render("Header") === "Lead ID" &&
                        !filters.tabs.FreshLeads
                      ? "stickLeadId zIndex1080 header"
                      : column.id === "selection"
                      ? "stickCheckbox zIndex1080 header"
                      : ((column.render("Header") === "Documents" ||
                          column.render("Header") === "Applied On") &&
                          filters.tabs.FreshLeads) ||
                        (!filters.tabs.FreshLeads &&
                          column.render("Header") === "Status") ||
                        (!filters.tabs.Work &&
                          !filters.tabs.Rejected &&
                          column.render("Header") === "Status Updated On") ||
                        ((filters.tabs.Work || filters.tabs.Rejected) &&
                          (column.render("Header") === "DOB" ||
                            column.render("Header") === "Preferred Pincodes" ||
                            column.render("Header") === "Languages" ||
                            column.render("Header") === "Assets" ||
                            column.render("Header") === "Qualifications" ||
                            column.render("Header") === "Documents")) ||
                        column.render("Header") === "Remarks"
                      ? "displayNone"
                      : "header"
                  }
                >
                  <span>{column.render("Header")}</span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        className={`${
                          cell.column.Header === "Name"
                            ? `${
                                !filters.tabs.FreshLeads
                                  ? "stickWorkerName95"
                                  : "stickWorkerNameV2"
                              }  zIndex540`
                            : cell.column.Header === "Lead ID" &&
                              !filters.tabs.FreshLeads
                            ? "stickLeadId zIndex540"
                            : cell.column.id === "selection"
                            ? "stickCheckbox zIndex540"
                            : ((cell.column.Header === "Documents" ||
                                cell.column.Header === "Applied On") &&
                                filters.tabs.FreshLeads) ||
                              (!filters.tabs.FreshLeads &&
                                cell.column.Header === "Status") ||
                              (!filters.tabs.Work &&
                                !filters.tabs.Rejected &&
                                cell.column.Header === "Status Updated On") ||
                              ((filters.tabs.Work || filters.tabs.Rejected) &&
                                (cell.column.Header === "DOB" ||
                                  cell.column.Header === "Preferred Pincodes" ||
                                  cell.column.Header === "Languages" ||
                                  cell.column.Header === "Assets" ||
                                  cell.column.Header === "Qualifications" ||
                                  cell.column.Header === "Documents")) ||
                              cell.column.Header === "Remarks"
                            ? "displayNone"
                            : "cell"
                        }`}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  );

  /* Useffects */

  useEffect(() => {
    fetchColumn();
  }, [userAction.edit]);

  useEffect(() => {
    let status = "";
    jobFilterOption === "active"
      ? (status = 1)
      : jobFilterOption === "inactive"
      ? (status = 2)
      : (status = "");

    Axios.get(
      `${UrlLinks.baseUrl}${UrlLinks.jobs.jobsdbListingNew}?paging=0${
        status ? `&status=${status}` : ""
      }&isTcs=0${
        localStorage.getItem("roleType") !== "6" &&
        localStorage.getItem("roleType") !== "31"
          ? `&projectIds=${assignedProjectIds}`
          : ""
      }`
    )
      .then((response) => {
        setJobList(makeJobData(response.data.response));
      })
      .catch((err) => {
        showToast("error", "Could not able to fetch job listing");
      });
  }, [jobFilterOption]);

  useEffect(() => {
    setAllRecordLoading(false);
  }, [allRecord]);

  useEffect(() => {
    if (selectedRowIds) {
      const indexes = Object.values(selectedRowIds);
      let disableButton = true;
      indexes.map((id) => {
        if (id) {
          disableButton = false;
          return true;
        }
        return true;
      });
      setIsRowSelected(disableButton);

      const indexValues = Object.entries(selectedRowIds);
      let assignIdList = [];
      let userIdList = [];
      indexValues.map((id) => {
        if (id[1]) {
          assignIdList.push(data[parseFloat(id[0])].assignId);
          userIdList.push(data[parseFloat(id[0])].userId);
        }
        return true;
      });
      assignIdList = assignIdList.join(",");
      setSelectedAssignIds(assignIdList);
      setSelectedUserIds(userIdList);
    }
  }, [selectedRowIds]);

  useEffect(() => {
    handleSearch();
  }, [searchKey]);

  useEffect(() => {
    let searchByVar = RemoveExtraSpaces(searchBy);
    let count = searchByVar.split(/[ ,]+/).length;
    if (count > 100) {
      setSearchError(true);
    } else {
      setSearchError(false);
    }
  }, [searchBy]);

  useEffect(() => {
    if (
      filters.appliedBetween[0] !== null ||
      filters.appliedBetween[1] !== null ||
      filters.assets !== "" ||
      filters.gender !== "" ||
      filters.leadCity !== "" ||
      filters.leadSource !== "" ||
      filters.mpaName !== "" ||
      filters.preferredLanguages !== "" ||
      filters.preferredPincodes !== "" ||
      filters.qualifications !== "" ||
      filters.recruiterId !== "" ||
      filters.recruiterAssignedBetween[0] !== null ||
      filters.recruiterAssignedBetween[1] !== null ||
      filters.statusUpdatedBetween[0] !== null ||
      filters.statusUpdatedBetween[1] !== null
    ) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, [filterUrl]);

  useEffect(() => {
    ApplyFilters(filters);
  }, [
    searchByAuto,
    searchKeyByAuto,
    tabValue,
    selectedOption,
    jobFilterOption,
    selectedSubStatus,
  ]);

  useEffect(() => {
    getExternalWorkerList(perPage, 1);
    setCurrentPage(1);
  }, [
    filterUrl,
    localStorage.getItem("roleType"),
    remarkChanged,
    toggleStatusUpdated,
  ]);

  useEffect(async () => {
    // Cancel the previous request if it exists
    if (cancelTokens.current.applicationStatus) {
      cancelTokens.current.applicationStatus.cancel(
        "Operation canceled due to new request."
      );
    }

    cancelTokens.current.applicationStatus = cancelTokenSource;

    // API for Lead Application Status
    try {
      setLoader(true);
      const response = await Axios.get(
        `${UrlLinks.baseUrl}${UrlLinks.leadData.getLeadApplicationStatus}`,
        {
          cancelToken: cancelTokenSource.token,
        }
      );
      if (response) {
        setSearchList(makeSearchList(response.data.response));
        setSubStatusList(makeSubStatusList(response.data.response, tabValue));
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (Axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        console.error("Error:", error);
      }
    }
  }, [tabValue]);

  useEffect(() => {
    fetchColumn();

    // API for Recruiter List
    Axios.get(`${UrlLinks.baseUrl}${UrlLinks.workerUrls.recruiterList}`).then(
      (response) => {
        setRecruiterList(makeRecruiterData(response.data.response.Content));
      }
    );

    // API for Ops List
    Axios.get(`${UrlLinks.baseUrl}${UrlLinks.leadData.getOpsListing}`).then(
      (response) => {
        setOpsList(makeOpsData(response.data.response));
      }
    );
  }, []);

  const loaderBar = (
    <div style={{ margin: "130px auto" }}>
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  return (
    <Styles>
      <Grid container className="padding2percent">
        <Grid item xs={12} className="flexDisplay marginBottom8">
          <Grid item xs={6} className="flexDisplay">
            <JobFilter
              uniqueKey="applicationDB"
              jobFilterOption={jobFilterOption}
              setJobFilterOption={setJobFilterOption}
              jobList={jobList}
              disabled={filters.tabs.FreshLeads}
              filters={filters}
              setFilters={setFilters}
              id="jobId"
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              jobFilterOptionList={jobFilterOptionList}
              placeholder="Type or search the jobs"
            />
          </Grid>
          <Grid item xs={6} className={`${styles.itemRowReverse}`}>
            {!!userAction.export_access && (
              <ExportButton
                uniqueKey="ApplicationDb"
                createAllRecordExcel={createAllRecordExcel}
                allRecordLoading={allRecordLoading}
                filename="Application DB.csv"
                buttonName="Export to Excel"
                loadingMessage="Please wait ... it might take few minutes."
                downloadButton="Download now"
                isDisabled={data.length === 0}
              />
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} className="flexDisplay">
          <Grid
            item
            xs={6}
            className="flexDisplay paddingTop8 justifySpaceBetween"
          >
            <SearchBar
              uniqueId="ApplicationDb"
              searchBy={searchBy}
              setSearchBy={setSearchBy}
              searchError={searchError}
              filters={filters}
              setFilters={setFilters}
              searchActions={searchActions}
              handleActions={handleActions}
              handleSearch={() => { trackEvent(FE_EVENTS.APPLICATION_SEARCH); handleSearch(); }}
              searchBarList={searchBarList}
              handleSearchClose={handleSearchClose}
              ApplyFilters={ApplyFilters}
              setFilterUrl={setFilterUrl}
              placeholder='Select "Search by" and search here'
              searchInstructions="Use comma or space as delimiter to search multiple pin., lead id. Max limit 100.
              "
              warningMessage=" Max limit reached. Search 100 pin max."
            />
          </Grid>
          <Grid
            item
            xs={6}
            className={`${styles.itemRowReverse} flexDisplay paddingTop8`}
          >
            {!!userAction.edit && (
              <ActionsDropdown
                uniqueKey="actionAppDb"
                actions={actions}
                handleActions={handleActions}
                actionList={actionList}
                isRowSelected={isRowSelected}
                dropdownName="Actions"
                searchList={uploadDataList}
                toggleStatusUpdated={toggleStatusUpdated}
                setToggleStatusUpdated={setToggleStatusUpdated}
              />
            )}
            {!!userAction.edit && (
              <div className="marginRight20">
                <CustomStatusDropdown
                  disabled={
                    (isRowSelected && !filters.tabs.Rejected) ||
                    filters.tabs.Rejected ||
                    (filters.tabs.FreshLeads && selectedSubStatus?.id === 16) ||
                    (filters.tabs.Applied && selectedSubStatus?.id !== 21) ||
                    (filters.tabs.Training && selectedSubStatus?.id !== 8) ||
                    (filters.tabs.Work && selectedSubStatus?.id !== 9)
                  }
                  searchList={searchList}
                  assignIds={
                    filters.tabs.FreshLeads
                      ? selectedUserIds
                      : selectedAssignIds
                  }
                  selectedSubStatus={selectedSubStatus}
                  dropdownName="Update status"
                  buttonName="Update"
                  toggleStatusUpdated={toggleStatusUpdated}
                  setToggleStatusUpdated={setToggleStatusUpdated}
                  uniqueKey="statusUpdate"
                  updateMyData={updateMyData}
                  fileName="Invalid lead data"
                />
              </div>
            )}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          className="flexDisplay paddingTop16"
          style={{ borderBottom: "1px solid #CECECE" }}
        >
          <Grid item xs={8}>
            <Tabs
              value={tabValue}
              onChange={(e, newIndex) => handleTabChange(e, newIndex)}
              aria-label="tab filter"
              className={`${classes.tabs}`}
              textColor="primary"
              indicatorColor="primary"
              TabIndicatorProps={{
                style: { background: "#1C4980" },
              }}
            >
              {tabsData.map((tab, index) => (
                <Tab
                  key={index}
                  value={tab.value}
                  label={tab.label}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Grid>
          <Grid item xs={4} className={`${styles.itemRowReverse}`}>
            <button
              className={`${styles.filterButton}`}
              onClick={() => setOpenFilterDrawer(true)}
            >
              {!isFilter ? (
                <img src={filterIcon} alt="filterIcon" />
              ) : (
                <img
                  src={filterIconMarked}
                  alt="filterIcon"
                  style={{ height: "16px" }}
                />
              )}
            </button>
            {selectedSubStatus && (
              <div
                className="marginRight20 flexDisplay"
                style={{ alignItems: "center" }}
              >
                <span style={{ marginRight: "8px" }}>Sub Status:</span>
                <span>
                  <JobFilter
                    uniqueKey="applicationDbSubStatus"
                    jobFilterOption={jobFilterOption}
                    setJobFilterOption={setJobFilterOption}
                    jobList={subStatusList}
                    filters={filters}
                    setFilters={setFilters}
                    id="status"
                    selectedOption={selectedSubStatus}
                    setSelectedOption={setSelectedSubStatus}
                  />
                </span>
              </div>
            )}
          </Grid>
        </Grid>
        {loader ? (
          loaderBar
        ) : data.length === 0 ? (
          <div className={styles.noRecord}>
            <img src={NoRecord} alt="noRecord" />
            <span>No records found</span>
            {!isDataVisible && (
              <span className={styles.jobWarning}>
                Please select a job to see the application data
              </span>
            )}
          </div>
        ) : (
          <Grid item xs={12} className="paddingTop16">
            {table}
            <Pagination
              rowsperpage={perPage}
              pageNo={currentPage}
              totalElements={totalRows}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
            />
          </Grid>
        )}
        {openRemarkModal && (
          <RemarkOkayGo
            open={openRemarkModal}
            setOpen={setOpenRemarkModal}
            setRemarkChanged={setRemarkChanged}
            record={remarkRecord}
            showToast={showToast}
            updateMyData={updateMyData}
            title="Remark"
            placeholder="Enter the Remark here"
            submitButton="Submit"
            cancelButton="Cancel"
          />
        )}
        {openApplicationHistoryModal && (
          <HistoryModal
            uniqueKey="applicationHistory"
            open={openApplicationHistoryModal}
            setOpen={setOpenApplicationHistoryModal}
            title={`Application History`}
            historyList={historyList}
            historyColumns={historyColumns}
            applicationStatusList={applicationStatusList}
          />
        )}
        {openWorkerHistoryModal && (
          <HistoryModal
            uniqueKey="workingHistory"
            open={openWorkerHistoryModal}
            setOpen={setOpenWorkerHistoryModal}
            title={`Working History`}
            historyList={historyList}
            historyColumns={historyColumns}
            applicationStatusList={applicationStatusList}
          />
        )}
        {openAssignRecruiterModal && (
          <AssignToRecruiter
            open={openAssignRecruiterModal}
            setOpen={setOpenAssignRecruiterModal}
            showToast={showToast}
            updateMyData={updateMyData}
            userIds={
              filters.tabs.FreshLeads ? selectedUserIds : selectedAssignIds
            }
            title="Assign to Recruiter"
            uniqueKey="recruiterAssign"
            placeholder="Enter the name here"
            buttonName="Assign to recruiter"
            optionList={recruiterList}
            url={`${UrlLinks.baseUrl}${
              filters.tabs.FreshLeads
                ? UrlLinks.leadData.assignToRecruiter
                : UrlLinks.leadData.assignAppliedLeadToRecruiter
            }`}
            unapplied={filters.tabs.FreshLeads}
          />
        )}
        {openAssignOpsModal && (
          <AssignToRecruiter
            open={openAssignOpsModal}
            setOpen={setOpenAssignOpsModal}
            showToast={showToast}
            updateMyData={updateMyData}
            userIds={
              filters.tabs.FreshLeads ? selectedUserIds : selectedAssignIds
            }
            title="Assign to operation team"
            uniqueKey="opsAssign"
            placeholder="Enter the name here"
            buttonName="Assign to ops"
            optionList={opsList}
            url={`${UrlLinks.baseUrl}${UrlLinks.leadData.assignLeadToOps}`}
            unapplied={filters.tabs.FreshLeads}
          />
        )}
        {openBulkUpdateModal && (
          <BulkUpdateModal
            openCasperOnboardingModal={openBulkUpdateModal}
            setOpenCasperOnboardingModal={setOpenBulkUpdateModal}
            statusValues={searchList}
            showToast={showToast}
            updateMyData={updateMyData}
            createAllRecordExcel={createAllRecordExcel}
            title="Bulk Update"
            uniqueKey="applicationDbBulkUpdate"
            unapplied={filters.tabs.FreshLeads}
            url={`${UrlLinks.baseUrl}${
              UrlLinks.leadData.updateLeads
            }?insertedBy=${localStorage.getItem("userID")}`}
            fileName="Invalid lead data"
          />
        )}
        {openUploadLeadModal && (
          <OnboardingModal
            openOnboardingModal={openUploadLeadModal}
            setOpenOnboardingModal={setOpenUploadLeadModal}
            showToast={showToast}
            updateMyData={updateMyData}
            title="Upload leads data"
            uniqueKey="uploadLeads"
            templateButton="Download File Template"
            url={`${UrlLinks.baseUrl}${
              UrlLinks.leadData.uploadLeads
            }?insertedBy=${localStorage.getItem("userID")}`}
            fileName="Invalid lead data"
          />
        )}
        {openMpaModal && (
          <OnboardingModal
            openOnboardingModal={openMpaModal}
            setOpenOnboardingModal={setOpenMpaModal}
            showToast={showToast}
            updateMyData={updateMyData}
            title="MPA Tagging"
            uniqueKey="mpaTaggingApplicationDB"
            templateButton="Download File Template"
            url={`${UrlLinks.baseUrl}${
              UrlLinks.workerUrls.tagUserMpa
            }?insertedBy=${localStorage.getItem("userID")}`}
            fileName="Invalid MPA data"
          />
        )}
        {openFilterDrawer && (
          <Drawer
            anchor="right"
            open={openFilterDrawer}
            onClose={() => {
              setLeadCityId(curLeadId.leadCity);
              setLeadSourceId(curLeadId.leadSource);
              setPreferredPincodes(multiplePreferredPincodes);
              setPreferredLanguages(multiplePreferredLanguages);
              setAssets(multipleAssets);
              setOpenFilterDrawer(false);
            }}
          >
            <FilterDrawer
              handleClose={() => setOpenFilterDrawer(false)}
              filters={filters}
              setFilters={setFilters}
              applyFilters={ApplyFilters}
              resetFilters={resetFiltersWithoutSearch}
              leadCityId={leadCityId}
              setLeadCityId={setLeadCityId}
              leadSourceId={leadSourceId}
              setLeadSourceId={setLeadSourceId}
              preferredPincodes={preferredPincodes}
              setPreferredPincodes={setPreferredPincodes}
              preferredLanguages={preferredLanguages}
              setPreferredLanguages={setPreferredLanguages}
              assets={assets}
              setAssets={setAssets}
              recruiterList={recruiterList}
              unapplied={filters.tabs.FreshLeads}
            ></FilterDrawer>
          </Drawer>
        )}
      </Grid>
    </Styles>
  );
};

export default ExternalWorker;
